import React from 'react'
import './InsightsCSS.css'; 
import ActivitySummary from './ActivitySummary';
import TimeRange from './TimeRange';
import DaySummary from './DaysSummary';
import PopularityStats from './PopularityStats';

function Insights() {
  return (
    <div className="insights-dashboard container">
      <h1>Data Insights Dashboard</h1>
      <ActivitySummary />
      <TimeRange />
      <DaySummary />
      <PopularityStats />
    </div>
  )
}

export default Insights